import {
    select,
    fork,
    put,
    all,
    call,
    takeEvery,
    takeLatest,
} from 'redux-saga/effects'
import { delay } from 'redux-saga'
import normalize from 'jsonapi-normalizer'
import {
    getRequest,
    get,
    post
} from 'helpers/RequestUtil'
import {
    CHANGE_PARTNER_SITE_SEARCH_QUERY,
    UPDATE_SELECTED_PARTNER_SITE,
    FETCH_PRODUCT_FAMILY_ENTITIES,
    SAVE_SUPPORT_TEAM,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES,
    CHANGE_EDIT,
    CHANGE_SELECT_PFPS,
    CHANGE_SEARCH_VALUE,
    CHANGE_PAGE_SIZE,
    CHANGE_CURRENT_PAGE,
    DELETE_PFPS_SUPPORT_TEAM
} from './constants'
import {
    partnerSiteQuerySelector,
    selectedPartnerSite,
    selectedProductFamily,
    searchValueSelector,
    currentPageSelector,
    editSelector,
    pageSizeSelector,
    currentPfpsSelector,
    formattedProductFamilyListSelector,
    productFamilyEntitiesSelector
} from './selectors'

import {
    siteRolesChanges
} from '../PartnerSiteRole/selectors'
import {
    buildUrl,
  } from 'helpers/actionHelper'
import { 
    fetchPartnerSitesError,
    fetchPartnerSitesStart,
    fetchPartnerSitesSuccess,
    startFetchPartnerSitesAsync,

    updateProductFamilyPartnerSiteTableList,
    clearProductFamilyPartnerSiteTableList,

    startFetchProductFamiliesAsync,
    fetchProductFamiliesStart,
    fetchProductFamiliesError,
    fetchProductFamiliesSuccess,

    startFetchProductFamilyEntitiesAsync,
    fetchProductFamilyEntitiesStart,
    fetchProductFamilyEntitiesSuccess,
    fetchProductFamilyEntitiesError,

    updateProductFamilyList,
    updateSelectedProductFamily,

    fetchProductFamilyPartnerSite,
    fetchProductFamilyPartnerSiteStart,
    fetchProductFamilyPartnerSiteSuccess,
    fetchProductFamilyPartnerSiteError,
    startFetchProductFamilyPartnerSiteAsync,

    startSaveSupportTeamAsync,
    saveSupportTeamRequestStart,
    saveSupportTeamRequestSuccess,
    saveSupportTeamRequestError,

    fetchProductFamilyRolesAsync,
    fetchProductFamilyRolesStart,
    fetchProductFamilyRolesSuccess,
    fetchProductFamilyRolesError,


    setInactiveProductFamilyDialog,
    clearProductFamilySelection,
    clearPartnerSite,

    updateEdit,
    updateCurrentPage,
    
    updateSelectPfps,
    setActivePfpsDialog,
    updateCountSize,
    updatePageSize,

    updatePfpsRoles,
    updateSelectedPartnerSite,
    updateSelectedPartnerSiteFromPfps,
    updateSelectedProductFamilyFromPfps,

    deletePfpsSupportTeam,
    startDeleteSupportTeamAsync,
    deletePfpsSupportTeamStart,
    deletePfpsSupportTeamSuccess,
    deletePfpsSupportTeamError,
    
} from './actions'

import {
    updateTablesAction,
} from 'containers/Entity/actions'

import {
    updateProductFamilyPartnerSiteList
} from './actions'

import {
    resetSiteRolesChange
} from '../PartnerSiteRole/actions'

import {
    updateSiteRoles,
    updateSiteRolesChange
} from '../PartnerSiteRole/actions'

import {
    siteRolesSelector
} from '../PartnerSiteRole/selectors'

function* fetchPartnerSites(url, query) {
    try {
        yield put(startFetchPartnerSitesAsync())
        yield put(fetchPartnerSitesStart())
        const data = yield call(
            getRequest,
            url
        )
        const normalized = normalize(data)
        yield put(updateProductFamilyPartnerSiteList(normalized.entities.sites))
        yield put(fetchPartnerSitesSuccess())
        return data
    } catch(error) {
        yield put(fetchPartnerSitesError(error))
    }
}

function* fetchProductFamilies(url) {
    try {
        yield put(startFetchProductFamiliesAsync())
        yield put(fetchProductFamiliesStart())
        const data = yield call(
            getRequest,
            url
        )
        const normalized = normalize(data)
        yield put(updateProductFamilyList(normalized.result.product_hierarchy_ids))
        yield put(fetchProductFamiliesSuccess())
    } catch(error) {
        yield put(fetchProductFamiliesError(error))
    }
}

function* fetchProductFamilyEntities(url) {
    try {
        yield put(startFetchProductFamilyEntitiesAsync())
        yield put(fetchProductFamilyEntitiesStart())
        const data = yield call(
            getRequest,
            url
        )
        const normalized = normalize(data)
        yield put(updateTablesAction(normalized))
        yield put(fetchProductFamilyEntitiesSuccess())
    } catch(error) {
        yield put(fetchProductFamilyEntitiesError(error))
    }
}

function* fetchProductFamilyPartnerSites(url) {
    try {
        yield put(startFetchProductFamilyPartnerSiteAsync())
        yield put(fetchProductFamilyPartnerSiteStart())
        const data = yield call(
            getRequest,
            url 
        )
        // yield put(update table)
        const normalized = normalize(data)
        yield put(updateProductFamilyPartnerSiteTableList(normalized.entities.pfps_mappings))
        yield put(updateCountSize(data.meta.totalCount))
        yield put(fetchProductFamilyPartnerSiteSuccess())
    } catch(error) {
        yield put(fetchProductFamilyPartnerSiteError(error))
    }
}

function* postSaveSupportTeam(url, partnerSiteId, productFamilyId, supportTeam) {
    try {
        yield put(startSaveSupportTeamAsync())
        yield put(saveSupportTeamRequestStart())
        const data = {
            partnerSiteId,
            productFamilyId,
            supportTeam
        }
        yield call(
            post,
            'product_family_partner_site_views',
            {data},
            url,
            false
        )
        yield put(saveSupportTeamRequestSuccess())
    } catch(error) {
        yield put(saveSupportTeamRequestError(error))
    }
}

function* postDeletePfpsSupportTeam(pfpsId, url) {
    try {
        yield put(startDeleteSupportTeamAsync())
        yield put(deletePfpsSupportTeamStart())
        const data = {
            pfpsId
        }
        yield call(
            post,
            'delete_pfps_views',
            {data},
            url,
            false
        )
        yield put(deletePfpsSupportTeamSuccess())
    } catch(error) {
        yield put(deletePfpsSupportTeamError(error))
    }
}


function* handlePartnerSiteQueryChange() {
    yield call(delay, 500)
    const query = yield select(partnerSiteQuerySelector)
    let params = [ { type: 'search', value: query} ]
    const url = yield buildUrl('/api/fulcrum/partner/sites', ...params)
    yield call(fetchPartnerSites, url)
}

function* handleSelectPartnerSiteChange(action) {
    yield call(delay, 500)
    if (action.value === null) {
        yield put(updateSelectedProductFamily(null))
    } else {
        const query = yield select(selectedPartnerSite)
        if (query) {
            let params = [ { type: 'search', value: query.value } ]
            const url = yield buildUrl('/api/fulcrum/partner/product_family_partner_site_views', ...params)
            yield call(fetchProductFamilies, url)
        }
    }
}

function* handleFetchProductFamilyEntities() {
    const query = true
    let params = [ { type: 'product_family', value: query } ]
    const url = yield buildUrl('/api/fulcrum/product_hierarchy_views', ...params)
    yield call(fetchProductFamilyEntities, url)
}

function* handleFetchProductFamilyPartnerSites() {
    let params = []
    yield call(delay, 500)
    const page = yield select(currentPageSelector)
    const size = yield select(pageSizeSelector)
    const searchValue = yield select(searchValueSelector)

    if (searchValue)
        params = [...params, { type: 'search', value: searchValue }]

    const url = yield buildUrl('/api/fulcrum/partner/pfps_mapping_views', ...params)
        .concat(`&page[number]=${page}&page[size]=${size}`)
    yield call(fetchProductFamilyPartnerSites, url)
}

function* handleSaveSupportTeam() {
    const partnerSite = yield select(selectedPartnerSite)
    const productFamily = yield select(selectedProductFamily)
    const supportTeam = yield select(siteRolesChanges)
    const url = '/api/fulcrum/partner/product_family_partner_site_views'
    yield call(postSaveSupportTeam, url, partnerSite, productFamily, supportTeam)
    yield put(resetSiteRolesChange())
    yield put(clearProductFamilySelection())
    yield put(clearPartnerSite())
    yield put(setInactiveProductFamilyDialog())
    yield fork(handleFetchProductFamilyPartnerSites)
}

function* handleDeletePfpsSupportTeam() {
    // get pfpsid
    // post id in payload to delete function
    // return and refresh the page
    const url = '/api/fulcrum/partner/delete_pfps_views'
    const pfps = yield select(currentPfpsSelector)
    yield call(postDeletePfpsSupportTeam, pfps.id, url)
    yield window.location.reload()
}

function* fetchProductFamilyRoles(pfpsId) {
    try {
        yield put(fetchProductFamilyRolesStart())
        const data = yield call(
            getRequest, 
            `/api/fulcrum/partner/sites/${pfpsId}/pfps_mapping_support_team_views`
        )
        yield put(fetchProductFamilyRolesSuccess())
        return data
    } catch (error) {
        yield put(fetchProductFamilyRolesError(error))
    }
}

function* handleChangeEdit(action) {
    const { enable } = action
    yield put(updateCurrentPage(1))
    yield put(updateEdit(enable))
    yield fork(fetchProductFamilyPartnerSite)
}

function* handleChangeSelectPfps(action) {
    const { id } = action
    yield put(updateSelectPfps(id))
    const pfps = yield select(currentPfpsSelector)
    let roles = yield call(fetchProductFamilyRoles, pfps.id)
    let entities = {'site_role_views': {}}
    let result = {'site_role_views': [] }
    roles.forEach((role)=> {
        entities['site_role_views'][role.id] = role 
        result['site_role_views'].push(role.id)
    })
    let data = {entities, result}
    yield put(updateTablesAction(data))
    yield put(updateSiteRoles(result['site_role_views']))
    const team = yield select(siteRolesSelector)
    yield put(updateSiteRolesChange(team))
    yield put(setActivePfpsDialog())
    // update partner site from pfps
    yield put(updateSelectedPartnerSiteFromPfps({ label: pfps.partner_site }))

    // update product family form pfps
    const productFamilyEntities = yield select(productFamilyEntitiesSelector)
    const selectedProductFamily = Object.values(productFamilyEntities).find((entity) => entity.name === pfps.product_family)
    yield put(updateSelectedProductFamilyFromPfps({ value: selectedProductFamily.id }))
}
function* handleSearchChange() {
    yield put(updateCurrentPage(1))
    yield put(clearProductFamilyPartnerSiteTableList())
    yield fork(handleFetchProductFamilyPartnerSites)
}

function* handleChangePageSize(action) {
    const { size } = action
    const page = yield select(currentPageSelector)
    const prevSize = yield select(pageSizeSelector)
    let newPage = Math.floor((page - 1) * prevSize / size)
    newPage = (newPage > 0)
      ? newPage
      : newPage + 1
  
    yield put(updatePageSize(size))
    yield put(updateCurrentPage(newPage))
    yield fork(handleFetchProductFamilyPartnerSites)
}

function* handleChangeCurrentPage(action) {
    const { value } = action
    const page = yield select(currentPageSelector)
    yield put(updateCurrentPage(page + value))
    yield fork(handleFetchProductFamilyPartnerSites)
  }

function* watchPartnerSiteSearchQuery() {
    yield takeLatest(CHANGE_PARTNER_SITE_SEARCH_QUERY, handlePartnerSiteQueryChange)
}

function* watchSelectPartnerSite() {
    yield takeLatest(UPDATE_SELECTED_PARTNER_SITE, handleSelectPartnerSiteChange)
}

function* watchFetchProductFamilyEntities() {
    yield takeLatest(FETCH_PRODUCT_FAMILY_ENTITIES, handleFetchProductFamilyEntities)
}

function* watchFetchProductFamilyPartnerSiteSupportTeam() {
    yield takeLatest(FETCH_PRODUCT_FAMILY_PARTNER_SITES, handleFetchProductFamilyPartnerSites)
}

function* watchSaveSupportTeam() {
    yield takeLatest(SAVE_SUPPORT_TEAM, handleSaveSupportTeam)
}

function* watchChangeEdit() {
    yield takeLatest(CHANGE_EDIT, handleChangeEdit)
}

function* watchChangeSearchValue() {
    yield takeLatest(CHANGE_SEARCH_VALUE, handleSearchChange)
}

function* watchChangePageSize() {
    yield takeLatest(CHANGE_PAGE_SIZE, handleChangePageSize)
}

function* watchChangeSelectPfps() {
    yield takeLatest(CHANGE_SELECT_PFPS, handleChangeSelectPfps)
}

function* watchChangeCurrentPage() {
    yield takeLatest(CHANGE_CURRENT_PAGE, handleChangeCurrentPage)
}

function* watchDeletePfpsSupportTeam() {
    yield takeLatest(DELETE_PFPS_SUPPORT_TEAM, handleDeletePfpsSupportTeam)
}

function* loadSagas() {
    yield all([
        fork(watchPartnerSiteSearchQuery),
        fork(watchSelectPartnerSite),
        fork(watchFetchProductFamilyEntities),
        fork(watchSaveSupportTeam),
        fork(watchFetchProductFamilyPartnerSiteSupportTeam),
        fork(watchChangeEdit),
        fork(watchChangeSearchValue),
        fork(watchChangePageSize),
        fork(watchChangeSelectPfps),
        fork(watchChangeCurrentPage),
        fork(watchDeletePfpsSupportTeam)
    ])
}

export default loadSagas